import React from "react";
import { Card, Col, Row, Typography } from "antd";

import FuelPriceStats from "../FuelPriceStats";
import PricePeriodFilters from "../PricePeriodFilters";
import PricePeriodTable from "../PricePeriodTable";

const { Paragraph, Text } = Typography;

const pillars = [
    {
        title: "主表扫描周期",
        description: "列表只展示供应商 x 机场 x 周期这一主记录，并用差额与状态暴露异常信号。",
    },
    {
        title: "浮层解释双快照",
        description: "点击价格单元格进入对比浮层，以 INTERNAL_REFERENCE vs SUPPLIER_QUOTE 语义解释差异。",
    },
    {
        title: "动作面向整个周期",
        description: "确认、争议、删除都属于周期级动作，不把状态机错误地下沉到单个分项。",
    },
];

const PricePeriodWorkbenchPanel = ({
    stats,
    filters,
    vendors,
    statusOptions,
    periods,
    loading,
    pagination,
    onFilterChange,
    onSearch,
    onReset,
    onCreate,
    onTableChange,
    onViewDetail,
    onOpenOurPrice,
    onOpenSupplierQuote,
    onConfirm,
    onDispute,
    onDelete,
    onOpenComparison,
}) => {
    return (
        <>
            <Card size="small" style={{ marginBottom: 16 }}>
                <Paragraph type="secondary" style={{ marginTop: 0 }}>
                    当前工作台围绕“主表 + 对比浮层 + 周期级动作语义”组织。主表用于快速发现异常周期，浮层用于解释双快照差异。
                </Paragraph>
                <Row gutter={[16, 16]}>
                    {pillars.map((pillar) => (
                        <Col xs={24} md={8} key={pillar.title}>
                            <Text strong>{pillar.title}</Text>
                            <div style={{ marginTop: 6, color: "rgba(0, 0, 0, 0.65)" }}>{pillar.description}</div>
                        </Col>
                    ))}
                </Row>
            </Card>

            <FuelPriceStats stats={stats} />

            <PricePeriodFilters
                filters={filters}
                vendors={vendors}
                statusOptions={statusOptions}
                onChange={onFilterChange}
                onSearch={onSearch}
                onReset={onReset}
                onCreate={onCreate}
            />

            <PricePeriodTable
                periods={periods}
                loading={loading}
                pagination={pagination}
                onTableChange={onTableChange}
                onViewDetail={onViewDetail}
                onOpenOurPrice={onOpenOurPrice}
                onOpenSupplierQuote={onOpenSupplierQuote}
                onConfirm={onConfirm}
                onDispute={onDispute}
                onDelete={onDelete}
                onOpenComparison={onOpenComparison}
            />
        </>
    );
};

export default PricePeriodWorkbenchPanel;
